import { IntlFormatters } from 'react-intl';

import { IRestaurant } from '@rbi-ctg/store';
import { ServiceMode } from 'state/service-mode/types';

export const getAddressMessage = ({
  store,
  noStoreSelected,
  isStoreOpenAndUnavailable,
  serviceMode,
  userAddress,
  formatMessage,
}: {
  store: IRestaurant;
  noStoreSelected: boolean;
  isStoreOpenAndUnavailable: boolean;
  serviceMode: string;
  userAddress: string;
  formatMessage: IntlFormatters['formatMessage'];
}) => {
  let addressMessage: string = formatMessage({ id: 'howWouldYouLikeToReceiveThisOrder' });
  const storeAddress = store.physicalAddress?.address1 || '';

  if (isStoreOpenAndUnavailable) {
    addressMessage = formatMessage({ id: 'yourSelectedRestaurantIs' }, { storeAddress });
  } else if (!noStoreSelected) {
    switch (serviceMode) {
      case ServiceMode.EAT_IN:
        addressMessage = `${formatMessage({ id: 'dineInAt' })} ${storeAddress}`;
        break;
      case ServiceMode.CURBSIDE:
        addressMessage = `${formatMessage({ id: 'curbsideAt' })} ${storeAddress}`;
        break;
      case ServiceMode.TAKEOUT:
        addressMessage = `${formatMessage({ id: 'pickUpAt' })} ${storeAddress}`;
        break;
      case ServiceMode.DRIVE_THRU:
        addressMessage = `${formatMessage({ id: 'driveThruAt' })} ${storeAddress}`;
        break;
      case ServiceMode.MOBILE_ORDER_DRIVE_THRU:
        addressMessage = `${formatMessage({ id: 'mobileOrderDriveThruAt' })} ${storeAddress}`;
        break;
      case ServiceMode.DELIVERY:
        const address = userAddress?.split(',')[0] || '';
        addressMessage = `${formatMessage({ id: 'deliverTo' })} ${address}`;
        break;
      default:
        addressMessage = `${formatMessage({ id: 'orderingFrom' })} ${storeAddress}`;
        break;
    }
  }
  return addressMessage;
};

export const getOrderingDisabledStoreSelectionMessage = ({
  store,
  formatMessage,
  isStoreOpenAndAvailable,
}: {
  store: IRestaurant;
  formatMessage: IntlFormatters['formatMessage'];
  isStoreOpenAndAvailable: boolean;
}): string => {
  const storeAddress = store.physicalAddress?.address1 || '';
  return isStoreOpenAndAvailable
    ? formatMessage({ id: 'yourSelectedRestaurantIs' }, { storeAddress })
    : formatMessage({ id: 'selectRestaurantToViewOffers' });
};
